import "./App.css";
import Home from "./components/Home.jsx";

function App() {
    return (
        <div className="App">
            <Home />
        </div>
    );
}

export default App;
